import axios from 'axios'
import { SET_AUCTION_ITEM, SET_SERVER_TIME } from './types'

export default {
  setAuctionItems ({ commit }, payload) {
    commit(SET_AUCTION_ITEM, payload)
  },
  setServerTime ({ commit }, payload) {
    commit(SET_SERVER_TIME, payload)
  },
  async requestAuctionItemList (state, parameters) {
    return axios.get('/api/auction', { params: parameters })
      .then(async response => {
          state.dispatch('setAuctionItems', response.data.data.data)
          state.dispatch('setServerTime', response.data.data.time)
          return Promise.resolve(response)
      })
      .catch(async error => {
          return Promise.reject(error)
      })
  },
  async addAuctionItem (state, parameters) {
    return axios.post('/api/auction/add', parameters)
      .then(async response => {
          return Promise.resolve(response)
      })
      .catch(async error => {
          return Promise.reject(error)
      })
  },
  async bidItem (state, parameters) {
    return axios.post('/api/auction/bid', parameters)
      .then(async response => {
          return Promise.resolve(response)
      })
      .catch(async error => {
          return Promise.reject(error)
      })
  },
  async claimItem (state, parameters) {
    return axios.post('/api/auction/claim', parameters)
      .then(async response => {
          return Promise.resolve(response)
      })
      .catch(async error => {
          return Promise.reject(error)
      })
  }
}